<template>
  <div class="w-full flex flex-wrap gap-2">

    <div v-if="productData == null" class="w-full flex flex-col gap-2 p-2">
      <p>
        <span class="font-bold">Type: </span>
        <span v-if="options.type === 'button-group'">Button Gruppe</span>
        <span v-if="options.type === 'drop-down'">Drop Down</span>
        <span v-if="options.type === 'list'">Liste</span>
      </p>
      <table>
        <thead>
        <tr>
          <th>Preview</th>
          <th>Label</th>
          <th>Key</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(btn, idx) in  options?.buttons">
          <td><img :src="btn.previewFilePath" alt="preview" style="max-height: 32px;"/></td>
          <td>{{ btn.label }}</td>
          <td>{{ btn.key }}</td>
        </tr>
        </tbody>
      </table>
    </div>


    <template v-else>

      <!-- Button Group -->
      <div v-if="options?.type === 'button-group'"
           class=" w-full grid flex-wrap rounded overflow-hidden border border-trader-input-border bg-trader-input-border gap-[1px] dark:border-0 dark:bg-trader-darker-gray"
           :class="{
            'grid-cols-1': options?.gridCols === 1, 'grid-cols-2': options?.gridCols === 2, 'grid-cols-3': options?.gridCols === 3,
            'grid-cols-4': options?.gridCols === 4,'grid-cols-5': options?.gridCols === 5,'grid-cols-6': options?.gridCols === 6,
            'grid-cols-7': options?.gridCols === 7,'grid-cols-8': options?.gridCols === 8,'grid-cols-9': options?.gridCols === 9,
            'grid-cols-10': options?.gridCols === 10
         }"
      >
        <div v-for="(btn, index) in options?.buttons" :key="index"
             class="flex-grow p-1 transition-colors cursor-pointer flex flex-col justify-center items-center"
             :data-key="btn.key" @click="handleButtonClick(btn)" :class="[
          isSelected(btn.key)
         ? 'bg-trader-blue text-white'
            : 'bg-white dark:bg-trader-dark-gray'
        ]"
        >

          <img
              v-if="btn.previewFilePath"
              :src="btn.previewFilePath"
              alt="preview"
              style="max-height: 32px;"
              class=""
              :class="{
              'icon-select' : isSelected(btn.key),
              'icon' : !isSelected(btn.key)
            }"
          />

          <div v-if="btn.label != ''">{{ btn.label }}</div>
        </div>
      </div>

      <!-- Drop Down -->
      <div v-if="options?.type === 'drop-down'" class="flex-grow">

        <div class="flex flex-col relative w-full">
          <div
              class="h-7 border dark:border-0 border-trader-input-border p-1 w-full shadow-inner-2 bg-white dark:bg-trader-dark-gray dark:rounded"
              :class="{ 'bg-inactive': readOnly }"
              @click="showDropdown = !showDropdown"
          >
            <div class="flex items-center justify-between">
              <div class="flex-grow flex overflow-hidden">
                <div v-for="(btn, index) in options?.buttons.filter((btn) => isSelected(btn.key))"
                     :key="btn.key"
                     class="flex items-center gap-2">

                  <img
                      v-if="btn.previewFilePath"
                      :src="btn.previewFilePath"
                      alt="preview"
                      style="max-height: 10px;"
                      class="icon">
                  <div>{{ btn.label }}</div>
                </div>

              </div>
              <div class="flex items-center gap-2">
                <i v-show="showDropdown" class="fa-solid fa-chevron-up"></i>
                <i v-show="!showDropdown" class="fa-solid fa-chevron-down"></i>
              </div>
            </div>


          </div>

          <div v-if="showDropdown"
               class="absolute top-7 left-0 border border-trader-input-border p-1 w-full shadow-inner-2 max-h-64 bg-white overflow-auto z-10">
            <div v-for="(btn, index) in options?.buttons"
                 :key="btn.key"
                 class="m-1 p-2 cursor-pointer flex items-center gap-2"
                 :class="{ 'bg-trader-blue text-white': isSelected(btn.key), 'hover:bg-trader-gray': !isSelected(btn.key) }"
                 @click="handleButtonClick(btn)">

              <img
                  v-if="btn.previewFilePath"
                  :src="btn.previewFilePath"
                  alt="preview"
                  style="max-height: 32px;"
                  class=""
                  :class="{
              'icon-select' : isSelected(btn.key),
              'icon' : !isSelected(btn.key)
            }"
              />

              <div v-if="btn.label != ''">{{ btn.label }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- list view with selection -->
      <div v-if="options?.type === 'list'"
           class="flex flex-col flex-grow border dark:border-0 border-trader-input-border p-1 w-full shadow-inner-2 bg-white dark:bg-trader-dark-gray dark:rounded gap-1">
        <div v-for="(btn, index) in options?.buttons"
             :key="index"
             class="flex items-center gap-2 cursor-pointer p-1"
             @click="handleButtonClick(btn)"
             :class="{ 'bg-trader-blue text-white': isSelected(btn.key), 'hover:bg-trader-gray': !isSelected(btn.key) }"
        >
          <img
              v-if="btn.previewFilePath"
              :src="btn.previewFilePath"
              alt="preview"
              style="max-height: 32px;"
              class=""
              :class="{
              'icon-select' : isSelected(btn.key),
              'icon' : !isSelected(btn.key)
            }"
          />
          <div>{{ btn.label }}</div>
        </div>
      </div>


    </template>

  </div>
</template>

<script>
import {eventBus} from "@/application/EventBus";
import DCustomizableSelectionOptions from "@/customizations/selgros/Dialogs/DCustomizableSelectionOptions.vue";

export default {
  meta: {
    name: "Benutzerdefinierte Selektion",
    type: "fieldtype",
    version: "1.0.0",
    hasOptions: true, // <- wichtig, damit du die Option "Einstellungen" im Editor bekommst
  },
  props: {
    name: "Benutzerdefinierte Selektion",
    formField: {
      type: Object,
      default: () => ({
        readOnly: false,
      })
    },
    productData: {
      type: Object,
      default: () => {
      }
    },
    onChangeProductFieldValue: {
      type: Function,
      default: () => {
      }
    },
    getFieldValue: {
      type: Function,
      default: () => {
      }
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    let parsed = {};
    try {
      parsed = JSON.parse(this.formField.value);
    } catch (e) {
    }

    return {
      showDropdown: false,
      options: parsed || {
        type: 'button-group',
        gridCols: 2,
        allowMultiselection: false,
        hasSymbols: false,
        buttons: []
      }
    }
  },
  methods: {
    isSelected(key) {
      if (this.options.allowMultiselection) {
        let stringValue = this.localGetFieldValue(this.formField.field) || "";

        let list = [];
        if (stringValue.includes(",")) {
          list = stringValue.split(',').map((item) => item.trim()).filter((item) => item !== '');
        } else {
          list = [stringValue];
        }

        return list.includes(key);
      } else {
        return this.localGetFieldValue(this.formField.field) === key;
      }
    },
    handleButtonClick(button) {
      if (this.options.allowMultiselection) {

        const value = this.getFieldValue(this.formField.field, 'string') || '';
        let splitted = value.split(',').map((item) => item.trim()).filter((item) => item !== '');


        let key = button.key.trim();
        const hasValue = splitted.includes(key);
        if (hasValue) {
          splitted = splitted.filter((item) => item !== key);
        } else {
          splitted.push(key);
        }

        this.onChangeProductFieldValue(this.formField.field, 'string', splitted.join(','));
      } else {
        this.showDropdown = false;
        this.onChangeProductFieldValue(this.formField.field, null, button.key);
      }
    },
    localGetFieldValue(fieldName) {
      return this.productData?.customFields[fieldName]?.value || '';
    }


  },
  created() {
    document.addEventListener('click', (e) => {
      if (!this.$el.contains(e.target)) {
        this.showDropdown = false;
      }
    });
  },
  showOptions(value, callback) {
    eventBus.openModal(
        DCustomizableSelectionOptions,
        {
          title: "Optionen für Button Group",
          setData: value,
          onApply: callback
        },
        {
          halfSize: true
        }
    );
  }
}
</script>

<style scoped>
.icon {
  filter: invert(0.3);
}

.icon-select {
  filter: invert(1.0);
}

.icon:is(.dark *) {
  filter: invert(1.0);
}

</style>
